import { render, staticRenderFns } from "./classes.vue?vue&type=template&id=6d002468&scoped=true&"
import script from "./classes.ts?vue&type=script&lang=ts&"
export * from "./classes.ts?vue&type=script&lang=ts&"
import style0 from "./classes.scss?vue&type=style&index=0&id=6d002468&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d002468",
  null
  
)

export default component.exports